import { tokenManager } from 'coral-utility';

export type IRoute = ((prefix: string) => string) | (() => string);

export enum RelationshipsEnums {
  INCLUDE_ALL_RELATIONS = '?include_all_relations=true',
  INCLUDE_RELATIONS = '?include_relations=true',
  NONE = '',
}
export interface IRequest {
  route: any;
  options: RequestInit;
}

export const genericHeaders = (): HeadersInit => ({
  'Content-Type': 'application/json',
});

export const genFetch = (request: IRequest) => {
  return (headers: HeadersInit = genericHeaders()) => {
    return (relations: RelationshipsEnums = RelationshipsEnums.NONE): Promise<Response> => {
      return fetch(`${request.route()}${relations}`, {
        ...request.options,
        headers,
      });
    };
  };
};

export const b64toBlob = (b64Data: string, contentType: string = '', sliceSize: number = 512) => {
  const byteCharacters = atob(b64Data.replace(/^data:.*;base64,/, ''));
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const convertBase64ToBlob = (Base64Image: any) => {
  // SPLIT INTO TWO PARTS
  const parts = Base64Image.split(';base64,');
  // HOLD THE CONTENT TYPE
  const imageType = parts[0].split(':')[1];
  // DECODE BASE64 STRING
  const decodedData = window.atob(parts[1]);
  // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
  const uInt8Array = new Uint8Array(decodedData.length);
  // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }
  // RETURN BLOB IMAGE AFTER CONVERSION
  return new Blob([uInt8Array], { type: imageType });
};

export const withToken = (headers = genericHeaders()): HeadersInit => ({
  ...headers,
  Authorization: `Bearer ${tokenManager.getToken()}`,
});
